import { Component, Input, OnInit } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'

@Component({
  selector: 'app-footer-template',
  templateUrl: './footer-template.component.html',
  styleUrl: './footer-template.component.scss'
})
export class FooterTemplateComponent implements OnInit {
  @Input() data: any
  @Input() currentYear!: number
  footerStyles: { [key: string]: string } = {}
  safeWaveSvg?: SafeHtml
  safeFloatSvg?: SafeHtml
  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.footerStyles = {
      'background-color': this.data?.footerBgImageUrl ? '#fff' : this.data?.bgColor || '#000',
      color: this.data?.textColor || '#fff',
      'background-repeat': 'no-repeat',
      // 'background-position': 'center',
      'background-size': 'cover',
      ...(this.data?.styleVars || {})
    }
    if (this.data?.wave?.svg) {
      this.safeWaveSvg = this.sanitizer?.bypassSecurityTrustHtml(this.data.wave.svg)
    }
    if (this.data?.layout?.floatingBar?.svg) {
      this.safeFloatSvg = this.sanitizer?.bypassSecurityTrustHtml(this.data.layout.floatingBar.svg)
    }
  }

  /** Bootstrap column class from layout */
  getColClass(width: number): string {
    return `col-lg-${width} col-md-6 mb-4 mb-lg-2`
  }

  /** Section helper */
  has(col: any, section: string): boolean {
    return col?.sections?.includes(section)
  }
}
